(function ($) {
    'use strict';

    var $el = $('[data-email-confirmed-check]');
    var $checkButton = $('[data-email-confirmed-check-button]');
    var $checkSuccessMsg = $('[data-email-confirmed-success-msg]');
    var $checkFailMsg = $('[data-email-confirmed-fail-msg]');
    var REQUEST_URL = $el.data('requestUrl');
    var $dataSourceItemId = $el.data('datasource');

    $checkButton.on('click', handleResendEmail);
    

    function handleResendEmail(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        $.post(REQUEST_URL, {dataSourceId: $dataSourceItemId })
			.done(handleSuccess)
			.fail(handleFail);
    }

    function handleSuccess(data) {
        if (data === false) {
            $checkFailMsg.show();
            $checkSuccessMsg.hide();
        } else {
            $checkSuccessMsg.show();
            $checkButton.hide();
            $checkFailMsg.hide();
        }
    }

    function handleFail(e) {
        console.log('failed');
        console.log(e);
        $checkFailMsg.show();
        $checkSuccessMsg.hide();
        $checkButton.show();
    }

})($jq);
